import { render, staticRenderFns } from "./faren.vue?vue&type=template&id=35c6e37d&scoped=true&"
import script from "./faren.vue?vue&type=script&lang=js&"
export * from "./faren.vue?vue&type=script&lang=js&"
import style0 from "./faren.vue?vue&type=style&index=0&id=35c6e37d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c6e37d",
  null
  
)

export default component.exports